module.exports = __webpack_public_path__ + "img/yumna-2.59a195dc.png";